<section class="app-field" [ngClass]="!valid ? 'app-field with-error' : 'app-field'" [class.field-disabled]="disabled">
  @if (leadingText) {
    <span>{{leadingText}} <p></p> </span>
  }
  @if (label) {
    <label>{{label}} @if (tooltipReference) {
        <app-tool-tip [trigger]="tooltipReference"></app-tool-tip>
      }

      @if (isRequired) {
        <span class="error-states red-asterisk"> *</span>
      }
    </label>
  }
  @if (label) {
    <br>
    }
    <table style="width: 100%">
      <tr>
        <td>
          <ng-content></ng-content>
        </td>
      </tr>
    </table>
    @if (!valid) {
      <div class="error-states error-container">
        {{errorMessage}}
      </div>
    }
  </section>